import React, { useEffect } from "react";
import MainBanner from "../sections/Home/MainBanner";
// import SuccessSlider from "../sections/Home/SuccessSlider";
import Services from "../sections/Home/Services";
import Blogs from "../sections/Home/Blogs";
import { Footer } from "../ComponentFile";
import LatestUpdates from "../sections/Home/LatestUpdates";
import BusinesEmpowerment from "../sections/Home/BusinesEmpowerment";
import FullLengthSlider from "../sections/AllServicesSlider/FullLengthSlider";
import {
  PUBLIC_FOOTER_SPACING_PROPS,
  PUBLIC_SECTION_GAP_CLASS,
  PUBLIC_BROWSE_SLIDER_ITEM_GAP_CLASS,
  PUBLIC_SLIDER_IMAGE_TO_LABEL_CLASS,
} from "../sections/Public/shared/publicLayoutSpec";

const Home = () => {
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="bg-pastalblue z-1">
        <MainBanner />
        {/* <SuccessSlider /> */}
        <Services />
        <LatestUpdates />
      </div>
      <BusinesEmpowerment />
      {/* <div className="bg-pastalBlueWhiteFooter z-1"> */}
        <Blogs />
        <FullLengthSlider
          className={PUBLIC_SECTION_GAP_CLASS}
          itemGapClassName={PUBLIC_BROWSE_SLIDER_ITEM_GAP_CLASS}
          labelClassName={PUBLIC_SLIDER_IMAGE_TO_LABEL_CLASS}
        />
        <Footer {...PUBLIC_FOOTER_SPACING_PROPS} />
      {/* </div> */}
    </>
  );
};

export default Home;